import { render, staticRenderFns } from "./related-products.vue?vue&type=template&id=4b8b311f&scoped=true"
import script from "./related-products.vue?vue&type=script&lang=js"
export * from "./related-products.vue?vue&type=script&lang=js"
import style0 from "./related-products.vue?vue&type=style&index=0&id=4b8b311f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b311f",
  null
  
)

export default component.exports